import type { PropsWithChildren } from 'react'

import { Alert, Loader } from '@components'
import { selectLoader } from '@store/loader'
import { theme, GlobalStyles } from '@theme'
import { GlobalThemeProvider } from '@applyft-web/ui-components'
import { useSelector } from 'react-redux'
import { useInitLocales } from '@/locales'

export function UiGate({ children }: PropsWithChildren) {
  const { ready, isRtl } = useInitLocales()
  const { show, message } = useSelector(selectLoader)

  if (!ready) return <Loader show={true} />

  return (
    <GlobalThemeProvider projectTheme={theme} isRtl={isRtl} enableRTL={true}>
      <GlobalStyles />
      {children}
      <Alert />
      <Loader show={show} message={message} />
    </GlobalThemeProvider>
  )
}
